import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import './animations.scss';

const spaceCharacterRegex = /\b \b/g;

export default function Icon({
  className,
  desc,
  id,
  name,
  role,
  styles,
  title,
  ...otherProps
}) {
  const SVG = require(`./icons/${name}-svg.js`).default;

  title = title || id;
  const titleID = `${title.replace(spaceCharacterRegex, "-")}-title`;
  const descID = `${titleID}-desc`;

  const containerSVGClassNames = cx(className, {
    "spinnerSVG": name === "spinner"
  });

  return (
    <svg
      aria-labelledby={`${titleID} ${descID}`}
      className={containerSVGClassNames}
      role={role}
      {...styles}
      {...otherProps}
    >
      <title id={titleID}>{title}</title>
      <desc id={descID}>{desc}</desc>
      <SVG
        className={className}
        id={id}
        styles={styles}
      />
    </svg>
  );
}

/** 
 *  title: should a be a short, usually one word, description of the SVG image.
 *  desc: A more in-depth description of the purpose of the SVG. For example:
          'Clickable icon button that opens a profile drawer to the left.'
    Both should be translated strings.
*/
Icon.propTypes = {
  className: PropTypes.string,
  desc: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  role: PropTypes.oneOf([
    "banner",
    "button",
    "checkbox",
    "img",
    "search"
  ]).isRequired,
  styles: PropTypes.object,
  title: PropTypes.string.isRequired
};

Icon.defaultProps = {
  role: "img",
  styles: {
    height: "32px",
    width: "32px"
  }
};
